import { useState } from "react"
import { ObraForm } from "./ObraForm/index"
import {  useQuery } from "@tanstack/react-query";
import { genericGet } from "../../../services/api.service";
import { useLocation } from "react-router-dom";
import { ObraDisplay } from "./ObraDisplay/index";
import RodrimaqSpinner from "../../../components/Spinner";

function wait(ms: number) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }

export default function Obra() {

    const location = useLocation();
    const [editing, setEditing] = useState<boolean>(false);

    const { data: obra, isLoading, refetch } = useQuery({
        queryKey: ['obra'],
        queryFn: async () => {
            return await genericGet(location.pathname);
        },
        suspense: false,
        cacheTime: 0
    });


    if(!obra || isLoading) return (<div className="flex h-[200px] justify-center">
        <RodrimaqSpinner message="Loading Obra..."/>
    </div>);


    return (
        <>
            {
            editing ? 
            <ObraForm obra={obra} onCancel={()=>{ 
                setEditing(false)
                refetch();
            }}/>
            
            : <ObraDisplay obra={obra} setEditing={setEditing} refetch={refetch}/>
            
            }
        </>
    )




}